import styled from 'styled-components'
import tw, { screen } from 'twin.macro'

export const Root = styled.div`
  ${tw`px-insetX py-insetY`};
`

export const Results = styled.div`
  & > *:first-child {
    ${tw`mt-0!`};
  }
`

export const ResultSet = styled.div`
  ${tw`mt-16`};
`

export const Columns = styled.div`
  ${tw`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8`};
`

export const CollectionsColumns = styled.div`
  ${tw`-my-1`};
  ${screen`sm`({ columnCount: 2 })};
  ${screen`md`({ columnCount: 3 })};
  ${screen`lg`({ columnCount: 4 })};
  column-gap: 2rem;
`

export const CollectionLink = styled.div`
  ${tw`py-1`};
  break-inside: avoid;
`
